<style scoped>
/* .table td, .table th {
    min-width: 110px;
    max-width: 110px;
} */
.r-custom tr td
{
    width: 14.28571%;
}

</style>
<template>

    <div class="" >
        <b-overlay :show="showoverlay" rounded="sm" class="col-md-12">
         <div class="clearfix row py-2 mb-2 no-margin">
            <!-- <div class="col-md-2 pr-0 cursor-pointer text-left pl-0">
                <b-input-group class="mb-2">
                    <b-input-group-prepend is-text>
                        Year
                    </b-input-group-prepend>
                    <b-form-select id="year" name="year" v-model="selected_fiscal_year" :options="years" @change="resetFiscalYear()"></b-form-select>
                </b-input-group>
            </div> -->
             <div class="col-md-2 pr-0 cursor-pointer text-left pl-0 form-group">
                <label for="year" class="d-block">Select Year</label>
                <b-input-group class="mb-2">
                    <b-form-select id="year" name="year" v-model="selected_fiscal_year" :options="years" @change="resetFiscalYear()"></b-form-select>
                </b-input-group>
            </div>
            <div class="col-md-10 no-margin p-0">
                <div class="row d-flex justify-content-end no-margin">
                    <b-button variant="secondary" class="d-flex justify-content-end m-1 btn-warning" @click="previewOrDownload(0)">Preview Report</b-button>
                    <b-button variant="secondary" class="d-flex justify-content-end m-1 btn-warning" @click="resetView()">Reset Selection</b-button>
                    <b-button variant="secondary" class="d-flex justify-content-end m-1 btn-warning" @click="previewOrDownload(1)">Download Report (Excel)</b-button>
                </div>
            </div>
        </div>
        <div v-if="this.is_grid_diplayable" >
            <!-- <common-list-leave-report :checkbox="checkbox" :leave_type_options="this.leave_type_options"   :appended_column="appended_column" :key="list_key" :company_options="company_options" :employees="custom_list" :default_column="default_column" :primary_key="primary_key" v-on:childToParent="listReturn"></common-list-leave-report> -->
            <common-list :checkbox="checkbox" :appended_column="appended_column" :key="list_key" :company_options="company_options" :employees="custom_list" :default_column="default_column" :primary_key="primary_key" v-on:childToParent="listReturn"></common-list>

        </div>
        <div class="card p-3" v-if="!this.is_grid_diplayable && this.is_preview" >
            <h4>Leave Report</h4>
            <div class="card-head">
                <!-- <h6>For the period  {{formatMe(this.day_one)}} to  {{formatMe(this.day_two)}} </h6> -->
            </div>
            <!-- class="bg-secondary text-white" -->
            <div class="card-body container px-0 "  >
                <!-- alpha fix- added class border  -->
                <table class="table text-center border">
                   <tr>

                                    <td>Name</td>
                                    <table class="table  r-custom">
                                       <tr>
                                            <td>Employee Code</td>
                                            <td>Leave Policy</td>
                                            <td>Leave Type</td>

                                            <td>Allowed Leaves</td>
                                            <td>Consumed Leaves</td>
                                            <td>Remaining Leaves</td>

                                            <td v-b-tooltip.hover title="Calculated after closing the leave year">Year Carry Forward</td>
                                            <td>Encash</td>

                                            <td>Carry Sum</td>
                                       </tr>
                                    </table>

                    </tr>
                    <!-- <tbody class="">                             -->
                        <template v-for="pdata in this.preview_data" >
                        <tr class="" v-if="pdata.leave_info != null">


                            <td> {{pdata.name}} </td>
                            <td  v-if="pdata.leave_info['available']!=''">
                                <table class="table  r-custom">
                                    <tr v-for="leaves in pdata.leave_info['available']">

                                        <td>{{pdata.employee_code }}</td>
                                        <td>{{pdata.leave_policy_info.title}}</td>
                                        <td>{{leaves.leave_title }}</td>

                                        <td v-if="leaves.leave_days">{{leaves.leave_days}}</td>
                                        <td v-else>{{leaves.leave_days}}</td>

                                        <td v-if="leaves.leave_taken_days">{{leaves.leave_taken_days}}</td>
                                        <td v-else>0</td>

                                        <td v-if="leaves.remaining_days">{{leaves.remaining_days}}</td>
                                        <td v-else>0</td>



                                        <td v-if="leaves.carried_days">{{leaves.carried_days}}</td>
                                        <td v-else>0</td>

                                        <td v-if="leaves.encashed">{{leaves.encashed}}</td>
                                        <td v-else>0</td>

                                        <td v-if="leaves.carry_sum">{{leaves.carry_sum}}</td>
                                        <td v-else>0</td>

                                    </tr>
                                  </table>

                            </td>



                            </tr>
                        </template>
                    <!-- </tbody> -->
                </table>
            </div>
        </div>
        </b-overlay>
    </div>
</template>


<script>
    export default{

        mounted() {

        },
        props: [],
        data(){
            const now = new Date()
            return {
                /**Child Component property data */
                selected: [],
                checkbox:1,
                is_action:1, /* As this list have actions then is_action will be 1. Otherwise it will be 0 */
                list_key:0, /* Component Key */
                custom_list:[],  /* Data List */
                default_column:['name','phone','email','jobposition','department','branch','leave_policy'], /* Default Column List */
                appended_column:[
                    // { value: "leave_policy", text: "Leave Policy",type: "dropdown"},
                ],
                leave_type_options:[],                /* Appended Column List  and there title and type */
                primary_key:'employee_id',  /* Primary is the unique key of the list this key will be returned if the row is clicked,
                                            for employee list is employee_id, For loan list it is loan_id etc here it is employee_id*/
                company_options:[],         /* Company Filterable options */

                /***Child Component property data */

                tmp_custom_list:[],
                // new
                /*years: [
                    { text: '2019-2020', value: '2019-2020' },
                    { text: '2020-2021', value: '2020-2021' },
                    { text: '2021-2022', value: '2021-2022' },
                    { text: '2022-2023', value: '2022-2023' },
                    { text: '2023-2024', value: '2023-2024' },
                ],*/
                years: [
                    { text: '2019', value: '2019' },
                    { text: '2020', value: '2020' },
                    { text: '2021', value: '2021' },
                    { text: '2022', value: '2022' },
                    { text: '2023', value: '2023' },
                    { text: '2024', value: '2024' },
                    { text: '2025', value: '2025' },
                    { text: '2026', value: '2026' },
                ],

                // selected_fiscal_year: '2021-2022',
                selected_fiscal_year: '',
                current_fiscal_year: now.getFullYear(),
                employee_ids: [],
                // new
                preview_data: '',
                is_preview: 0,
                is_grid_diplayable: 1,

                showoverlay : false,
            }
        },
        methods:{

            /* This is the child component return funtion.
            It will return if any row or action is clicked with primary_key and action_id (if any action is clicked otherwise action id will be 0)
            We can then trigger appropriate funtion depending on primary key and action id.
            */
           resetView: function()
            {
                this.is_grid_diplayable = 1;
                this.preview_data = '';
                this.selected = '';
                this.list_key +=1;

            },
           resetFiscalYear:function(){
               console.log('Resetted Fiscal Yera: '+this.selected_fiscal_year);
               this.$cookies.set("saved_fiscal_year_in_reporting",this.selected_fiscal_year);
               this.getCustomList();
               this.resetView();
           },
            listReturn:function(data)
            {
                this.selected = data;

                console.log(data);

            },

            getCustomList: function()
            {

                if(!this.checkNet()) return false;
                let currentObj = this;
                this.showoverlay = true;
                axios.get(this.$api_url+'/leaveattendancereport/getcustomlist?year='+this.selected_fiscal_year , {

                }).then(function(response){

                    /* Assingning the list */
                    this.tmp_custom_list = response.data.employee_data;
                    this.leave_type_options = response.data.leave_type_options;
                    /* Assingning the Options */
                    this.company_options = response.data.options;

                    /* Now if we have actions in this grid then we have to create an additional key in each row and assing the actions for each row accordingly */
                    if(this.tmp_custom_list.length > 0 )
                    {
                        this.tmp_custom_list.forEach(element => {

                                if(element.leave_type.length>0)
                                {
                                    let types = [];
                                    let type_ids = [];
                                    element.leave_type.forEach(newelement => {

                                        types.push(newelement.value);
                                        type_ids.push(newelement.id);

                                        });

                                        element.leave_types = types.join(" , ");
                                        element.leave_type_ids = type_ids;
                                }
                                else
                                {
                                    element.leave_types = 'Not Available';
                                    element.leave_type_ids = [];

                                }
                             });

                    }

                    this.custom_list = this.tmp_custom_list;
                    this.showoverlay = false;

                    this.list_key = this.list_key + 1;
                }.bind(this)).catch(function (error){currentObj.serverError(error);});

            },
            previewOrDownload: function(flg)
            {
                console.log(this.selected.leave_type_id);
               if(!this.checkNet()) return false;

                if (typeof this.selected.selected == 'undefined')
                    this.$bvToast.toast("Please select employee(s) to generate report", {title: 'Error!',variant: 'danger',solid: true, toaster: "toaster: b-toaster-top-right"});
                else if (this.selected.selected == '')
                    this.$bvToast.toast("Please select employee(s) to generate report", {title: 'Error!',variant: 'danger',solid: true, toaster: "toaster: b-toaster-top-right"});
                else if (typeof this.selected_fiscal_year == 'undefined')
                    this.$bvToast.toast("No from date selected", {title: 'Error!',variant: 'danger',solid: true, toaster: "toaster: b-toaster-top-right"});

                else
                {
                    let currentObj = this;
                    if(flg == 0)
                    {
                        this.$bvToast.toast('We are generating the report, this may take a while, please hold tight.', {
                                            title: `Info`,
                                            variant: 'info',
                                            solid: true
                                        });
                    }
                    else if(flg == 1)
                    {
                        this.$bvToast.toast('We are downloading the report, this may take a while, please hold tight.', {
                            title: `Info`,
                            variant: 'info',
                            solid: true
                        });
                    }





                    this.showoverlay = true;
                    // let formData = new FormData();
                    // formData.append('employee_ids', this.selected);
                    // formData.append('flg', flg);

                    axios.post(this.$api_url+'/employee/leaves/details/report',{
                    //  params: {
                            employee_ids: this.selected.selected,
                            from_date: this.day_one,
                            fiscal_year: this.selected_fiscal_year,
                            is_export: flg,
                            leave_type_id: this.selected.leave_type_id,
                        // }

                }).then(function(response){
                            {
                                this.showoverlay = false;
                                console.log('From response recieve');


                                if(flg == 0)
                                {
                                    this.preview_data = response.data;
                                    console.log(response.data);
                                    this.is_preview = 1;
                                    this.is_grid_diplayable = 0;
                                }
                                else if(flg == 1)
                                {
                                    // this.is_preview = 0;
                                    console.log('from dowload as an excel');
                                    //window.open(response.data);
                                    console.log(response);
                                    var fileURL = response.data;

                                    this.downloadFileContent(fileURL);
                                }


                            }}.bind(this)).catch(function (error){ currentObj.serverError(error);});

                }
            },
            download_file(fileURL)
            {
                if(!this.checkNet()) return false;

                var fileName = fileURL.substring(fileURL.lastIndexOf('/')+1);
                if (!window.ActiveXObject) {
                    var save = document.createElement('a');
                    save.href = fileURL;
                    save.target = '_blank';
                    //var filename = fileURL.substring(fileURL.lastIndexOf('/')+1);
                    save.download = fileName || filename;
                    if ( navigator.userAgent.toLowerCase().match(/(ipad|iphone|safari)/) && navigator.userAgent.search("Chrome") < 0) {
                            document.location = save.href;
                        }else{
                            var evt = new MouseEvent('click', {
                                'view': window,
                                'bubbles': true,
                                'cancelable': false
                            });
                            save.dispatchEvent(evt);
                            (window.URL || window.webkitURL).revokeObjectURL(save.href);
                        }
                }
                else if ( !! window.ActiveXObject && document.execCommand)     {
                    var _window = window.open(fileURL, '_blank');
                    _window.document.close();
                    _window.document.execCommand('SaveAs', true, fileName || fileURL)
                    _window.close();
                }
            },
            get_current_fiscal_year: function()
            {

                if(this.saved_fiscal_year != null && this.saved_fiscal_year != 'undefined')
                {
                    this.selected_fiscal_year = this.saved_fiscal_year;

                }
                else
                {

                    this.selected_fiscal_year = this.current_fiscal_year;


                }

                return;
                //console.log('From Fiscal Year get method.');
                //
                if(!this.checkNet()) return false;
                axios.get(this.$api_url+'/getcurrentfiscalyear' , {
                }).then(function(response){
                    this.current_fiscal_year = response.data;
                    //console.log('get current fiscal year function '+this.current_fiscal_year);
                    // if save fiscal year exist then display  saved in cookies fiscal year else from current_fiscal_year
                    let saved_fiscal_year = this.$cookies.get("saved_fiscal_year_in_reporting");

                    if(saved_fiscal_year != null && saved_fiscal_year != 'undefined')
                    {
                        this.selected_fiscal_year = saved_fiscal_year;

                    }
                    else
                    {

                        this.selected_fiscal_year = this.current_fiscal_year;


                    }

                }.bind(this));
            },


        },
        created: function(){

            /* fetchin the default list  with employee data */
            this.get_current_fiscal_year();
            this.getCustomList();



        }
    }
</script>
